/**
 * DEPRECATED — this file used to host a hand-written axios wrapper for the
 * pre-contracts endpoints. It now only exposes a tiny helper that builds the
 * public PDF-preview URL for the <iframe> on the signing page. All actual API
 * calls go through the swagger-generated `preContractsApi` exported from
 * `api/index.ts` (see `PreContractsApi` in `api/generated/api.ts`, regenerated
 * by `npm run generate-api`).
 *
 * If you delete this file, also delete the import in `PreContractSignPage.tsx`.
 */
import { realAxios } from './index';

export const getPreContractPreviewUrl = (token: string, tenant: string): string =>
  `${realAxios.defaults.baseURL}/pre-contracts/by-token/pdf?token=${encodeURIComponent(
    token,
  )}&tenant=${encodeURIComponent(tenant)}`;
